module.exports = __webpack_public_path__ + "images/hienfeld_smalla794704e04e97889337ed67ce75cec23.png";